module.exports = __webpack_public_path__ + "static/media/BottomIcon.57d4af38.svg";